/*
 *
 * Package: `@dbh/line-limitator-theme`.
 *
 */const lineLimitatorTheme={ellipsis:{width:{xs:"1.25rem",sm:"1.75rem",md:"2rem",lg:"2.25rem"}}};

export { lineLimitatorTheme as default };
